import CaseReviewReportView from '@/views/generic/caseReview/CaseReviewReportView'
import ReviewReportFindingsView from '@/views/generic/caseReview/ReviewReportFindingsView'
import ReviewReportCommentsView from '@/views/generic/caseReview/ReviewReportCommentsView'
import CaseCreateInvoiceView from '@/views/generic/invoicing/CaseCreateInvoiceView'
import InvoiceDetailsView from '@/views/generic/invoicing/InvoiceDetailsView'
import InvoiceEditView from '@/views/generic/invoicing/InvoiceEditView'
import CustomerDetailView from '@/views/generic/customerViews/CustomerDetailView'
import InvoicingView from '@/views/generic/invoicing/InvoicingView'
import DocumentsView from '@/views/generic/customerViews/DocumentsView'
import MessagingView from '@/views/generic/customerViews/MessagingView'
import CustomerCasesView from '@/views/generic/customerViews/CustomerCasesView'
import CaseCustomerView from '@/views/generic/caseView/CaseCustomerView'
import CaseInvoiceView from '@/views/generic/caseView/CaseInvoiceView'
import ReportsCompletedView from '@/views/generic/reporting/ReportsCompletedView'
import CustomerCertificatesView from '@/views/generic/customerViews/CustomerCertificatesView'
import SmsLogView from '@/views/generic/customerViews/SmsLogView'
import CaseSmsLogView from '@/views/generic/caseView/CaseSmsLogView'
import CaseMsgView from '@/views/generic/caseView/CaseMsgView'

let genericRoutes = [
  {
    path: '/cases/:caseId/review-report',
    component: CaseReviewReportView,
    props: true,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'ReviewReportFindingsView',
        component: ReviewReportFindingsView,
        props: true
      },
      {
        path: 'comments',
        name: 'ReviewReportCommentsView',
        component: ReviewReportCommentsView,
        props: true
      }
    ]
  },
  {
    path: '/cases/:caseId/invoice',
    name: 'CaseCreateInvoiceView',
    component: CaseCreateInvoiceView,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/invoices/:invoiceId',
    name: 'InvoiceDetailsView',
    component: InvoiceDetailsView,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/invoices/:invoiceId/edit',
    name: 'InvoiceEditView',
    component: InvoiceEditView,
    props: true,
    meta: { requiresAuth: true }
  }
]

let customerDetailRoutes = [
  {
    path: '/customers/:customerId',
    component: CustomerDetailView,
    props: true,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'InvoicingView',
        component: InvoicingView,
        props: true
      },
      {
        path: 'documents',
        name: 'DocumentsView',
        component: DocumentsView,
        props: true
      },
      {
        path: 'messaging',
        name: 'MessagingView',
        component: MessagingView,
        props: true
      },
      {
        path: 'cases',
        name: 'CustomerCasesView',
        component: CustomerCasesView,
        props: true
      },
      {
        path: 'certificates',
        name: 'CustomerCertificatesView',
        component: CustomerCertificatesView,
        props: true
      },
      {
        path: 'sms-log',
        name: 'SmsLogView',
        component: SmsLogView,
        props: true
      }
    ]
  }
]

let genericChildRoutes = {
  CaseView: {
    path: '',
    name: 'CaseView',
    component: CaseCustomerView,
    props: true
  },
  CaseInvoiceView: {
    path: 'invoices',
    name: 'CaseInvoiceView',
    component: CaseInvoiceView,
    props: true
  },
  CaseMsgView: {
    path: 'msg',
    name: 'CaseMsgView',
    component: CaseMsgView,
    props: true
  },
  CaseReviewFindingsView: {
    path: '',
    name: 'CaseReviewFindingsView',
    component: ReviewReportFindingsView,
    props: true
  },
  CaseReviewCommentsView: {
    path: 'comments',
    name: 'CaseReviewCommentsView',
    component: ReviewReportCommentsView,
    props: true
  },
  ReportsCompletedView: {
    path: 'completed',
    name: 'ReportsCompletedView',
    component: ReportsCompletedView,
    props: true
  },
  DocumentsView: {
    path: 'documents',
    name: 'DocumentsView',
    component: DocumentsView,
    props: true
  },
  MessagingView: {
    path: 'messaging',
    name: 'MessagingView',
    component: MessagingView,
    props: true
  },
  CustomerCasesView: {
    path: 'cases',
    name: 'CustomerCasesView',
    component: CustomerCasesView,
    props: true
  },
  CustomerCertificatesView: {
    path: 'certificates',
    name: 'CustomerCertificatesView',
    component: CustomerCertificatesView,
    props: true
  },
  CaseSmsLogView: {
    path: 'sms_logs',
    name: 'CaseSmsLogView',
    component: CaseSmsLogView,
    props: true
  }
}

export {
  genericRoutes,
  genericChildRoutes,
  customerDetailRoutes
}
